import { SharedService } from './../../services/sharedService/shared.service';
import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { AppComponent } from './../../app.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ToastrService } from "ngx-toastr";

import { ExcelService } from './../../services/excel.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { error } from 'jquery';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult, WorkerUrlPrefetchResultType } from 'src/serviceworker/service/prefetch';
import { LoaderService } from 'src/app/loader.service';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-manage-clients',
  templateUrl: './manage-clients.component.html',
  styleUrls: ['./manage-clients.component.css'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.Emulated
})
export class ManageClientsComponent implements OnDestroy, OnInit {
  brokerList: Array<any> = [];
  clientList: Array<any> = [];
  myDateValue: Date;
  dateFormat = 'YYYY-MM-DD';

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  persons: Array<any> = [];


  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  dtTrigger4: Subject<any> = new Subject<any>();


  selectedRow: number = -1;
  customerslist: Array<any> = [];
  message: any;
  checkboxesForMail: any
  isCorporate: boolean
  languageData:any;
  showfilter: boolean = false;
  role: any;
  employeelist: Array<any> = [];
  groupPlansList: any;
  fusbillid: any;
  paymentMethodId: any;
  showmemberData = false;
  corporateCompany: any;
  corporateCompany1: any;
  valuFormChaild: any = 1;
  clientDetails: any;
  loader: boolean;
  terminationform: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),

  });
  terminationformDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),
    refundAmount: new FormControl(),

  });
  minDate: any;
  terminateReasonsWithKeys: any;
  terminateMemberDetails: any;
  terminateParentDetails: any;
  terminateAllDetails:any;
  bulkPlanEmployeeIds:any = [];
  servicDetails: any;
  terminateReasonsApplicable: any;
  staxbillDetails: any;
  proceedWithSubscriptionExpiry: any;
  proceedWithEquitable: any;
  proceedWithGreenshield: any;
  proceedWithRefund: any;
  proceedWithSmartchoice: any;
  proceedWithCancelCustomer: any;
  terminationsProvisioning: any;
  employeeFirstName: any;
  employeeLastName: any;
  corporateName:any;
  refundAmount:any;
  memberid: any;
  version: string;
  allClientList: any[];
  filterStatus: any[];
  employeelistfilter: any;
  corporateCustomerAccount: any;

  corporatename: any;
  employeelist2: any[];
  abc: string;
  terminationDateValue: any;
  @ViewChild('dp') dpicker: ElementRef;
  corporateBulkPlan: any;
  isSubscribed: any;
  public lang: any = {};
  selectedLanguage: string;

  constructor(private logger: LoggerService,
    private toastrService: ToastrService,
    private SharedService: SharedService,
    private CommonService: CommonPatternsService,
    private _LoaderService: LoaderService, private formBuilder: FormBuilder, private formBuilderDetails: FormBuilder, private http: HttpClient, public router: Router, private datePipe: DatePipe, private excelService: ExcelService,) { }

  ngOnInit() {
this.getLanguageTokens()
    this.isSubscribed = false
    // this._LoaderService.ShowLoader()
    this.version = environment.version;
    this.role = sessionStorage.getItem('role');
    // this.setMinDateBasedOnRole()
    // this.ShowDetails()

    this.terminationform = this.formBuilder.group({
      reason: [
        ''

      ],
      memberstatus: [
        ''

      ],
      terminationDate: [
        '',
        [Validators.required],
      ],

    });
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: this.lang.Search_here
      },
      columnDefs: [
        {
          targets: '_all', // Index of the 'id' column
          orderable: false, // Disable sorting for this column
        },
      ],
    };

    this.getclientList();


    // this.getServiceWorkerDetails()

  }
  public getLanguageTokens(){
    let body= {
      "project":"Admin Portal",
      "url":"manageCorporates"
    }
    this.http
    .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.languageData = response.strings
        this.selectedLanguage = sessionStorage.getItem("language")
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }

        console.log(this.lang)

      })


  }

  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/admin/corporate/details/false';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //     $("#DataTables_Table_0").dataTable().fnDestroy();

  //     // this._LoaderService.HideLoader()


  //     setTimeout(() => {
  //       this.clientList = results[0].response.data
  //       // this.clientList = (response as any).data;
  //       this.filterStatus = [];
  //       this.clientList.map((member) => {
  //         if (!this.filterStatus.includes(member.status))
  //           this.filterStatus.push(member.status);
  //       });
  //       this.allClientList = this.clientList;
  //       this.clientList.sort((a, b) => {

  //         const order = { true: 1, false: 2, cancelled: 3 };

  //         if (order[a.status] !== order[b.status]) {
  //           return order[a.status] - order[b.status];
  //         }


  //         return a.name.trim().localeCompare(b.name.trim());
  //       });
  //       this.dtTrigger.next(null);
  //       setTimeout(() => {
  //         this.showfilter = true;
  //       }, 1000);
  //     }, 1000);



  //   })
  // }
  selectRow(i) {
    this.selectedRow = i;
    this.logger.log(this.selectedRow, "row")
  }
  public note: string = ""
  public enroll: any
  setMinDateBasedOnRoleAndStatus(client: any) {
    const today = new Date();
    if (this.role === 'BROKER') {
      this.minDate = today;
      this.note = this.lang.Required_backdated_selection_contact_Administrator
      return
    } else if (this.role === 'ADMINISTRATOR') {
      const threeMonthsFromNow = new Date(today.setMonth(today.getMonth() - 3));
      this.minDate = new Date(threeMonthsFromNow.getFullYear(), threeMonthsFromNow.getMonth(), 1);
      if (client.status === "Active" && client.planActivationDate) {
        this.enroll = new Date(client.planActivationDate)
        if (this.minDate <= this.enroll && this.enroll < new Date()) {
          this.minDate = this.enroll
          this.note = this.lang.enrollment_date_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }
        if (this.minDate < this.enroll && this.enroll >= new Date()) {
          this.minDate = new Date()
          this.note = this.lang.Today_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)

          return
        }
        this.note = this.lang.Can_select_from_3_months_from_the_past
      }
      if (client.status === "Draft") {
        this.minDate = null
        this.note = ""
        return
        // this.logger.log("mindate draft", this.minDate)
      }
      this.logger.log("mindate", this.minDate)
    }

  }

  terminationformDetailsValidations() {
    this.terminationformDetails = this.formBuilderDetails.group({
      reason: ['', [Validators.required],],
      memberstatus: ['', [Validators.required],],
      terminationDate: ['', [Validators.required],],
      proceedWithEquitable: [''],
      proceedWithGreenshield: [''],
      proceedWithRefund: [''],
      proceedWithSmartchoice: [''],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],
      refundAmount: [''],

    });
  }

  isDisabled(){
    const checkVal = this.terminateParentDetails?.staxbillDetails ? this.terminateParentDetails?.staxbillDetails?.refundApplicable == false ? true : false : true
    return checkVal;
  }

  changeStatus(e: any) {
    this.showfilter = false;
    $("#DataTables_Table_0").dataTable().fnDestroy();
    this.clientList = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.clientList = this.allClientList;
    } else {
      this.clientList = this.allClientList.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
    }
    this.dtTrigger.next(null);
    this.logger.log(this.clientList);
    // this.dtTrigger.next(null);
    // this.dtTrigger.unsubscribe();

    setTimeout(() => {
      this.showfilter = true;

    }, 500);

  }

  changeStatusmembers(e: any) {
    $("#DataTables_Table_1").dataTable().fnDestroy();
    this.employeelistfilter = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val

    if (val == 'all') {
      this.employeelistfilter = [...this.employeelist];
    } else {
      this.employeelistfilter = this.employeelist.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
      this.logger.log({ empfilter: this.employeelist })
    }
    this.dtTrigger1.next(null);
    this.logger.log(this.employeelistfilter);
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
      this.dtTrigger3.next(null);
    });
  }


  terminatemember(client: any, index: number) {
    // console.log(client)
    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(client)
    this.corporateName = client.name;
    this.memberid = client.uId;
    $("#terminateConfirmDateModal").modal('show');
    $("#showmemberlist").modal('hide')
    $("#DataTables_Table_1").dataTable().fnDestroy();


  }
  submitterminationEnd() {

    //here we have to update every member details


    this.terminateAllDetails.forEach(cust => {
      cust.proceedWithGreenshield = cust.proceedWithGreenshield ? this.terminationformDetails.get('proceedWithGreenshield').value : cust.proceedWithGreenshield;
      cust.proceedWithRefund = cust.proceedWithRefund ? this.terminationformDetails.get('proceedWithRefund').value : cust.proceedWithRefund;
      cust.proceedWithSmartchoice = cust.proceedWithSmartchoice ? this.terminationformDetails.get('proceedWithSmartchoice').value : cust.proceedWithSmartchoice;
      cust.proceedWithSubscriptionExpiry = cust.proceedWithSubscriptionExpiry ? this.terminationformDetails.get('proceedWithSubscriptionExpiry').value : cust.proceedWithSubscriptionExpiry;
      cust.proceedWithCancelCustomer = cust.proceedWithCancelCustomer ? this.terminationformDetails.get('proceedWithCancelCustomer').value : cust.proceedWithCancelCustomer
      cust.proceedWithEquitable = cust.proceedWithEquitable ? this.terminationformDetails.get('proceedWithEquitable').value : cust.proceedWithEquitable
      cust.refundAmount = cust.refundAmount ? this.terminationformDetails.get('refundAmount').value : cust.refundAmount
    })


    let data = {
      'data': this.terminateAllDetails,
      'bulkPlanEmployeeIds':this.bulkPlanEmployeeIds,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
    };
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminate2382';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers })
      .subscribe(async (responce: any) => {
        if (responce.status == '200') {

          var getClients = 'api/ap/admin/corporate/details/false';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + getClients
          // ]);

          Swal.fire({ title: "Info", html: responce.message }).then((res) => {
            if (res.isConfirmed) {
              this.getclientList();
              // this.getServiceWorkerDetails()
              $("#DataTables_Table_0").dataTable().fnDestroy();
              // this.dtTrigger.next(null);
            }
          });
          $('#showTerminateMemberDetails').modal('hide');

        } else {
          Swal.fire({ title: "info", text: responce.data.message });
        }

      }, (error) => {
        Swal.fire({ title: "Error", text: error.message || error.data.message });
      })
  }
  closeTerminatePopup(id: any) {
    $(`#${id}`).modal("hide");
    this.terminationform.reset();
  }


  onClick(i){
    console.log(i)
  }
  submittermination() {
    if (this.terminationform.invalid) {
      this.logger.log(this.terminationform.invalid)
      this.toastrService.error(`Minimium Date : ${moment(this.minDate).format('MM-DD-YYYY')} \n Note: ${this.note}`);
      this.terminationform.markAllAsTouched()
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/admin/corporate/' + this.memberid + '/terminateConfiguration';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            $("#terminateConfirmDateModal").modal('hide');
            $('#showTerminateMemberDetails').modal('show');
            let terminationGSDetails = []
            let allMemberDetails = response.data;
            this.terminateMemberDetails = response.data.filter((p:any) => !p.isParentAccount);
            this.terminateParentDetails = response.data.find((p:any) => p.isParentAccount);
            this.terminateAllDetails = response.data;

            this.bulkPlanEmployeeIds = response.bulkPlanEmployeeIds;


            // alert(this.terminateMemberDetails.serviceType)

            this.logger.log("asasasa", this.terminateMemberDetails);
            this.terminateReasonsApplicable = this.terminateParentDetails.terminateReasonsApplicable;
            this.servicDetails = this.terminateParentDetails.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateParentDetails.staxbillDetails;

            this.terminationsProvisioning = this.terminateParentDetails.terminationsProvisioning[0]
            let proceedWithEquitable = this.terminationsProvisioning.proceedWithEquitable;
            let proceedWithGreenshield = this.terminationsProvisioning.proceedWithGreenshield;
            let proceedWithRefund = this.terminateParentDetails.proceedWithRefund;
            let proceedWithSmartchoice = this.terminationsProvisioning.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateParentDetails.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateParentDetails.proceedWithCancelCustomer;
            let refundAmount = this.terminateParentDetails.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.terminateParentDetails.staxbillDetails.refundAmount;


            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);

            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: 'Info', text: response.message })
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        }
      );
  }

  closeModelPopup(id: any) {
    this.logger.log(id)
    $('#' + id).modal('hide');
  }



  // terminatemember(client: any, index: number) {


  //   this.emplomentName = client.name

  //   this.memberid = client.id

  //   Swal.fire({
  //     title: 'Info',
  //     text: 'Are you sure you want to Terminate?',
  //     showCancelButton: true,
  //     confirmButtonColor: '#10104d',
  //     cancelButtonColor: '#10104d',
  //     confirmButtonText: 'Yes',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       $("#terminatemember").modal('show')
  //     }
  //   });

  // }
  // submittermination() {

  //   this.logger.log(this.terminationform.value)


  //   let data = {
  //     "reason": this.terminationform.value.reason,
  //     "memberStatus": this.terminationform.value.memberstatus,
  //     "terminationDate": this.datePipe.transform(
  //       this.terminationform.value.terminationDate,
  //       'MM-dd-yyyy'
  //     ) || ''
  //   }

  //   var corporateId = sessionStorage.getItem('corporateId');
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   var terminate = '/api/ap/member/' + this.memberid + '/terminate';
  //   this.http
  //     .post(environment.apiUrl + terminate, data, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         if (response['status'] == 200 || response['statusCode'] == 200) {
  //           $("#terminatemember").modal('hide')
  //           this.getclientList()

  //         } else {
  //           Swal.fire({ title: 'Error', text: response.message })
  //         }
  //       },
  //       (error) => {
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: 'Error',
  //             text: error.error.error.message,
  //             showDenyButton: false,
  //             showCancelButton: true,
  //             confirmButtonText: 'Proceed',
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //             else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //       }
  //     );
  // }
  viewsubBrokerList(brokerlist) {

    $('#subGroupList-modal').modal('show');
    this.logger.log(brokerlist)
    this.customerslist = brokerlist
    // $("#DataTables_Table_1").dataTable().OnDestroy()
    $("#DataTables_Table_1").dataTable().fnDestroy();

  }


  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;




  sendInvitationEmail(details: any, index: any) {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/member/${details.uId}/inviteMail`;
    // https://testadminapi.groupbenefitz.aitestpro.com/api/ap/member/20271/inviteMail
    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporate/1660/invitation
    this.http.get(environment.apiUrl + GetBrokers, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {

      if (response['status'] == 200 || response['statusCode'] == 200) {
        Swal.fire({ title: "Info", text: response.message })
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }


    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }

  invitationCorporate(details: any, index: any) {
    this.isCorporate = true
    this.message = this.lang.Send_portal_access_link_to + `${details.name}`

    const accessToken = sessionStorage.getItem('accessToken');
    const getGroupContacts = `/api/ap/admin/corporate/${details.id}/groupAdmins`;
    this.loader = true
    this.http.get(environment.apiUrl + getGroupContacts, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      this.loader = false
      if (response['status'] == 200 || response['statusCode'] == 200) {
        const checkboxes = response.data
        this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
          const obj = {
            label: `${c.roleNameDisplay == "Others" ? c.roleName.charAt(0).toUpperCase() + c.roleName.slice(1).toLowerCase() :  c.roleNameDisplay.charAt(0).toUpperCase() + c.roleNameDisplay.slice(1).toLowerCase()} ${c.firstName} ${c.lastName} {${c.email}}`,
            checked: false,
            id: c.groupAdminId
          }
          return obj
        }
        )
        this.inviteGroupContacts(details.id)
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      this.loader = false
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

    this.logger.log("checboxes", this.checkboxesForMail)

  }


  invitationbroker(details: any, index: any) {
    this.isCorporate = false

    this.message = this.lang.Send_access_link_to_Member_Portal_for + `${details.firstName} ${details.lastName} ?`

    $('#confirmationModal').modal('show');

    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.sendInvitationEmail(details, index);
        }
        $('#confirmationModal').modal('hide');
      });
    }
  }


  inviteGroupContacts(id: number) {

    $('#confirmationModal').modal('show');
    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.logger.log(obj)
          const brokerAdminIds = obj.selectedCheckboxes.map((o, i) => (o.id))
          if (obj.confirmed) {
            const accessToken = sessionStorage.getItem('accessToken');
            const GetBrokers = `/api/ap/admin/corporate/${id}/invitation`;
            this.http.post(environment.apiUrl + GetBrokers, { brokerAdminIds }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((response: any) => {

              if (response['status'] == 200 || response['statusCode'] == 200) {
                Swal.fire({ title: "Info", text: response.message })
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }


            }), (error) => {
              Swal.fire({ title: 'Error', text: error.error.error.message });
            }
          }
        }
        $('#confirmationModal').modal('hide');
      });

    }
  }

  public viewBrokerDetails(broker: any, index: number) {
    const showTiles = broker.adminApproved;
    if (showTiles) {
      this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
    } else {
      this.router.navigate(['/manageCorporates/edit-corporate/' + broker.id]);
    }


  }
  public viewMemberDetails(member: any, index: number) {

    $("#showmemberlist").modal('hide')
    sessionStorage.setItem("customerId", member.uId)
    this.SharedService.setUserName(member.firstName + " " + member.lastName)

    this.router.navigate(['/manageMembers/employee/' + member.uId + '/details']);


  }
  // public viewMemberDetails(member:any,index:number){

  //   $("#showmemberlist").modal('hide')
  //     sessionStorage.setItem("customerId",member.uId)
  //     this.router.navigate(['/employee/'+member.uId+'/details']);

  //   }
  public viewBrokerCustomers(broker: any, index: number) {
    $('#subGroupList-modal').modal('hide');
    this.router.navigate(['/advsiors/' + broker.id + '/customers']);

    // /broker/{brokerId}/details

  }




  async ShowDetails(data: any, id: any) {


    this.employeelist = []
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    // var GetBrokers = `/api/ap/broker/${id}/details`;
    var GetEmployees = `/api/ap/admin/corporate/${id}/nonbulk/employees`

    // await postServiceWorkerMessage(WorkerMessageType.Delete, [
    //               environment.apiUrl + GetEmployees
    //             ]);

    this.http.get(environment.apiUrl + GetEmployees, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] == 200 || response['statusCode'] == 200) {
        this.logger.log("responce details", JSON.stringify(response));

        // this.employeelist = response.data.employees
        $("#showmemberlist").modal('show')

        this.employeelist = response.data.nonBulkEmployee.sort((a, b) => {

          const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }

          return a.firstName.trim().localeCompare(b.firstName.trim());
        });

        this.corporateCustomerAccount = response.data.corporateCustomerAccount

        this.corporateCompany = data.name

        this.dtTrigger1.next(null);
        // $('#showmemberlist').show();
      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }

  closelist() {
    this.employeelist = [];
    $("#showmemberlist").modal('hide')
    $("#DataTables_Table_1").dataTable().fnDestroy();


  }

  ShowGroupPlansDetails(data: any, id: any) {
    this.logger.log("bulk count", data.bulkEmployeeCount)

    var accessToken = sessionStorage.getItem('accessToken');
    const getGroupPlansList = `/api/ap/admin/corporate/${id}/bulk/employees`


    this.http.get(environment.apiUrl + getGroupPlansList, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response['status'] == 200 || response['statusCode'] == 200) {
        this.logger.log("responce grp plans", JSON.stringify(response));

        $("#DataTables_Table_2").dataTable().fnDestroy();
        $("#DataTables_Table_3").dataTable().fnDestroy();



        this.groupPlansList = response.data.bulkEmployee
        this.corporateCustomerAccount = response.data.corporateCustomerAccount
        this.corporateBulkPlan = response.data.corporateBulkPlan.sort((a, b) => {

          const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }

          return a.planLevel?.trim().localeCompare(b.PlanLevel?.trim());
        })
        this.logger.log({ bulkplans: this.corporateBulkPlan })

        this.corporateCompany1 = data.name
        this.dtTrigger4.next(null)
        this.dtTrigger3.next(null)
        $('#showGroupPlansList').show();


      } else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }), (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message });
    }

  }


  public addClientDetails() {
    this.router.navigate(['/manageCorporates/addCorporate']);
  }

  addEmployee(client) {
    //  alert(compName)
    sessionStorage.setItem('corpId', client.id);
    sessionStorage.setItem("compName", client.name);
    sessionStorage.setItem("compFormId", client.formId);

    this.router.navigate(['/manageCorporates/addEmployee']);
    // alert('1212')
  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public getclientList() {

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var getClients = '/api/ap/admin/corporate/details/false';
    this.loader = true;


    this.http
      .get(environment.apiUrl + getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.loader = false;
            this.clientList = (response as any).data;
            this.filterStatus = [];
            this.clientList.map((member) => {
              if (!this.filterStatus.includes(member.status))
                this.filterStatus.push(member.status);
            });
            this.allClientList = this.clientList;
            this.clientList.sort((a, b) => {

              const order = { true: 1, false: 2, cancelled: 3 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              // const result = a.name.localeCompare(b.name);
              // return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
              return a.name.trim().localeCompare(b.name.trim());
            });
            this.dtTrigger.next(null);
            setTimeout(() => {
              this.showfilter = true;
            }, 1000);

          } else {
            this.loader = false
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          this.loader = false;
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this ' + broker.brokerType + '?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            async (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                // window.location.reload()
                // this.getBrokerList()

                var getClients = 'api/ap/admin/corporate/details/false';

                // await postServiceWorkerMessage(WorkerMessageType.Delete, [
                //   environment.apiUrl + getClients
                // ]);
                this.getclientList()
                // this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }

  public memberStatus(member: any, event: any, index: number) {
    $("#DataTables_Table_0").dataTable().fnDestroy();
    // $("#DataTables_Table_0").dataTable().fnDestroy();
    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/customer/' + member.uId + '/status/' + event

    let obj = {}
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to change ' + member.firstName + ' status?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // $("#DataTables_Table_0").dataTable().fnDestroy();

        this.http
          .put(environment.apiUrl + brokerStatus, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(

            async (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                var getClients = 'api/ap/admin/corporate/details/false';

                // await postServiceWorkerMessage(WorkerMessageType.Delete, [
                //   environment.apiUrl + getClients
                // ]);
                this.getclientList();

                // this.getServiceWorkerDetails()
                // this.logger.log(this.clientList);
                // window.location.reload()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }

          );
      }
      else {
        var getClients = 'api/ap/admin/corporate/details/false';

        // await postServiceWorkerMessage(WorkerMessageType.Delete, [
        //   environment.apiUrl + getClients
        // ]);
        this.getclientList();
        // this.getServiceWorkerDetails()
      }
    })

  }



  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.dtTrigger1.unsubscribe();
    this.dtTrigger2.unsubscribe();
    this.dtTrigger3.unsubscribe();

  }
}
export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}

